module.exports = __webpack_public_path__ + "images/doc-folder-list-e43d07d71a9300d1ad1e5348610659e5.png";